import React, { FC, useState } from 'react';
import logoIcon from 'assets/svg/logo.svg';
import closeIconInModal from 'assets/svg/close-icon-in-modal.svg';
import sendInviteTicker from 'assets/svg/send-invite-ticker.svg';
import InputField from 'components/textField/InputField';
import Button from 'components/button/Button';
import ModalShell from 'components/chatModal/ChatModalShell.module.scss';
import Styles from 'views/inviteFriend/InviteFriend.module.scss';
import { validateEmail, validatePhone } from 'helpers/utils';

interface InviteFriendProps {
  cssClass?: string;
  invitePeople: Function;
  loading: boolean;
  invitation: string;
  isPopup?: boolean;
  closePopup?: (event?: React.FormEvent<HTMLDivElement>) => void;
}

const InviteFriend: FC<InviteFriendProps> = (props: InviteFriendProps) => {
  const { cssClass, invitePeople, loading, invitation, isPopup, closePopup } = props;
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [formError, setFormError] = useState('');

  const handleInvite = () => {
    const trimmedEmail = email.trim();
    const trimmedPhone = phone.trim();
    const hasEmail = trimmedEmail.length > 0;
    const hasPhone = trimmedPhone.length > 0;

    if (!hasEmail && !hasPhone) {
      setFormError('Enter a phone number or email.');
      setEmailError(false);
      setPhoneError(false);
      return;
    }

    setFormError('');

    let nextEmailError = false;
    let nextPhoneError = false;

    if (hasEmail && !validateEmail(trimmedEmail)) {
      nextEmailError = true;
    }
    if (hasPhone && !validatePhone(trimmedPhone)) {
      nextPhoneError = true;
    }

    setEmailError(nextEmailError);
    setPhoneError(nextPhoneError);

    if (nextEmailError || nextPhoneError) {
      return;
    }

    if (hasPhone) {
      invitePeople({ phone: trimmedPhone });
    }
    if (hasEmail) {
      invitePeople({ email: trimmedEmail });
    }

    setEmail('');
    setPhone('');
  };

  const formFields = (
    <>
      <div className={Styles.inviteFriend}>
        <img src={logoIcon} alt="" className={Styles.logoIcon} />
        <h3>
          Invite a friend! If they accept, we’ll deposit a Gold
          <br />
          Piece into your account.
        </h3>
        <p>You can send the invite via text or email.</p>
      </div>
      <div className={Styles.formWrapper}>
        <div className={`form-group ${Styles.fieldGroup}`}>
          <InputField
            placeholder="Enter phone number"
            type="tel"
            value={phone}
            cssClass={Styles.inviteInput}
            handleChange={(value: string) => {
              setPhone(value);
              if (phoneError) setPhoneError(false);
              if (formError) setFormError('');
            }}
          />
          {phoneError && <p className={Styles.fieldError}>Invalid phone number</p>}
        </div>

        <div className={Styles.orDivider} aria-hidden="true">
          <h6>
            <span>or</span>
          </h6>
        </div>

        <div className={`form-group ${Styles.fieldGroup}`}>
          <InputField
            placeholder="Enter email"
            type="email"
            value={email}
            cssClass={Styles.inviteInput}
            handleChange={(value: string) => {
              setEmail(value);
              if (emailError) setEmailError(false);
              if (formError) setFormError('');
            }}
          />
          {emailError && <p className={Styles.fieldError}>Invalid email</p>}
        </div>

        {formError && <p className={Styles.fieldError}>{formError}</p>}
        {invitation && <p className={Styles.fieldSuccess}>{invitation}</p>}

        {!isPopup && (
          <Button
            label="SEND INVITE"
            cssClass={`mt-4 ${Styles.sendInvitePageBtn}`}
            showLoading={loading}
            clickHandler={handleInvite}
            image
            src={sendInviteTicker}
            alt=""
            imageClass={Styles.sendInviteTicker}
          />
        )}
      </div>
    </>
  );

  if (isPopup) {
    return (
      <>
        <div className={Styles.popupBody}>
          <div className={Styles.popupInner}>{formFields}</div>
        </div>
        <div className={ModalShell.footer}>
          <div className={Styles.popupFooterActions}>
            <button
              type="button"
              className={ModalShell.closeBtn}
              onClick={() => closePopup?.()}
            >
              Close
              <img src={closeIconInModal} alt="" className={ModalShell.closeIcon} />
            </button>
            <button
              type="button"
              className={Styles.sendInviteBtn}
              onClick={handleInvite}
              disabled={loading}
            >
              {loading ? 'Sending…' : 'Send Invite'}
              {!loading && (
                <img src={sendInviteTicker} alt="" className={Styles.sendInviteTickerPopup} />
              )}
            </button>
          </div>
        </div>
      </>
    );
  }

  return (
    <div className={Styles.settingsContent}>
      <div className={`${Styles.pageCard} ${cssClass || ''}`}>{formFields}</div>
    </div>
  );
};
export default InviteFriend;
